import { Provider } from '@angular/core';

import { MainApi } from '@mark/web-contracts';

import { CommonGrpcContractFactory } from './common.service.provider';

export const OrderV2GrpcContractProvider: Provider = {
  provide: MainApi.OrderV2GrpcContractClient,
  useFactory: CommonGrpcContractFactory(MainApi.OrderV2GrpcContractClient, 'main2Api'),
};
